import { Directive, ElementRef, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BuilderInfoService } from '@portal/builder';

@Directive({
  selector: '[portalCustomBackgroundClassDirective]',
  standalone: false,
})
export class CustomBackgroundClassDirective implements OnInit {
  private readonly el = inject<ElementRef<HTMLDivElement>>(ElementRef);
  private readonly builderInfoService = inject(BuilderInfoService);

  ngOnInit(): void {
    const useCustomForeground = this.builderInfoService.settings?.useCustomBackground;
    if (useCustomForeground) {
      this.el.nativeElement.classList.add('custom-background');
    }
  }
}
